import { ValueAccessorBase } from './value-accessor-base';
import { ViewChild, Input, ApplicationRef, Output, EventEmitter, Directive } from '@angular/core';
import { NgModel } from '@angular/forms';
import { ILabel } from './ILabel.model';
import { FormulaBuilderConfig, FormulaBuilderType } from './cpq-formula-builder/cpq-formula-builder.model';
import { KeyboardCode } from './common/enums/keyboard-code';
import { MatDialog } from '@angular/material/dialog';
import { CpqFormulaBuilderComponent } from './cpq-formula-builder/cpq-formula-builder.component';

@Directive()
export class CpqInputBase extends ValueAccessorBase<string> {
  @ViewChild(NgModel, { static: true }) model: NgModel;
  @Input('placeholder') placeholder: string;
  @Input('name') name: string;
  @Input('type') type = 'text';
  @Input('label') label: ILabel;
  @Input('config') config?: FormulaBuilderConfig;
  @Input('tabindex') tabindex?: number;
  @Input('infoMessage') infoMessage?: ILabel;
  @Input('disabled') disabled: boolean;
  @Output('onInfoClick') onInfoClick = new EventEmitter<any>();
  @Output('onFocusOut') onFocusOut = new EventEmitter<any>();

  /**
   *
   * @param applicationRef Used for change detection when value is updated via formula builder.
   * This parameter should be removed when new formula builder is introduced.
   */
  constructor(public applicationRef: ApplicationRef,
    public formulaBuilderDialog: MatDialog) {
    super();
  }

  public openFormulaBuilder(formula: string) {
    const self = this;
    this.config.formula = formula;

    this.formulaBuilderDialog.open(CpqFormulaBuilderComponent, {
      data : this.config
    }).afterClosed().subscribe(response => {
      self.value = response;
    });
  }

  onEnter(event: KeyboardEvent) {
    switch (event.key) {
      case KeyboardCode.ENTER || KeyboardCode.NUMPAD_ENTER:
        event.preventDefault();
        break;
      default:
        break;
    }
  }

  infoClicked() {
    this.onInfoClick.emit();
  }
}

